import React, { useContext } from 'react';

import { TableViewContext } from 'providers';
import {
  DEFAULT_COLUMN_VISIBILITY,
  DISABLED_COLUMN_VISIBILITY,
} from 'constants/table';
import VisibilityOptions from 'ui/VisibilityOptions';

const ProductListingOptions = () => {
  const { visibleFields, handleVisibleFieldsChange } =
    useContext(TableViewContext);

  return (
    <VisibilityOptions
      defaultOptions={DEFAULT_COLUMN_VISIBILITY}
      disabledOptions={DISABLED_COLUMN_VISIBILITY}
      selectedOptions={visibleFields}
      onSelectedOptionsChange={handleVisibleFieldsChange}
    />
  );
};

export default ProductListingOptions;
